import jwtDecodeLib from 'jwt-decode'

// Keep in sync with /packages/server/src/utils/jwt.js
export const jwtDecode = (jwt) => {
	let jwtDecoded
	try {
		jwtDecoded = jwtDecodeLib(jwt)
	} catch (error) {
		console.error(error)
	}
	return jwtDecoded
}
